function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_printer"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 6h-2v-3c0-.553-.447-1-1-1h-9c-.553 0-1 .447-1 1s.447 1 1 1h8v2h-4c-.553 0-1 .447-1 1s.447 1 1 1h8v8c0 .553.447 1 1 1s1-.447 1-1v-8c0-1.103-.897-2-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.71 9.29c-.19-.18-.45-.29-.71-.29s-.52.11-.71.29c-.181.19-.29.45-.29.71s.109.52.29.71c.38.37 1.04.37 1.42 0 .18-.19.29-.45.29-.71s-.11-.52-.29-.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.293 2.293h-.586c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h2v3c0 .553.447 1 1 1h10c.553 0 1-.447 1-1v-1.586l2.293 2.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm2.293 12.707v1h-2v-8h2.586l6 6h-5.586c-.553 0-1 .447-1 1zm10 5h-8v-4h6.586l1.414 1.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 17h-4c-.553 0-1 .447-1 1s.447 1 1 1h4c.553 0 1-.447 1-1s-.447-1-1-1z"
})));

var Svg079Printer = function Svg079Printer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg079Printer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/079-printer.a46787e0.svg";
export { ForwardRef as ReactComponent };